import {Link, useRoute} from 'wouter'

export function NavLink({to, title, ...props}: {to: string; title: string}) {
  const route = useRoute(to)

  return route[0] ? (
    <Link to={to} {...props}>
      <strong>{title}</strong>
    </Link>
  ) : (
    <Link to={to} {...props}>
      <u>{title}</u>
    </Link>
  )
}

export function NavLinks() {
  return (
    <div className='flex gap-3 place-items-center'>
      <NavLink to='/photos' title='Photos' />
      <NavLink to='/charts' title='Charts' />
      <NavLink to='/files' title='Files' />
    </div>
  )
}
